/**
 * Created by Jan on 27.09.2019.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ZzDev = Lfl.ZzDev || {};

    (function (ZzDev, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.ZzDev, 'MobileDebugger')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Helps with debugging info on mobile devices.
         *
         * Note: ZzDev::AddJsDebuggingForIos::ActuallyIzAlsoAndroid: Not only for iOS, also Android, other mobile and IE
         * (mobile & debile).
         *
         * @memberOf Lfl.ZzDev
         */
        Lfl.ZzDev.MobileDebugger = ZzDev.MobileDebugger || {};

        (function (MobileDebugger, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            var DEBUGGING_TOOLS_WRAPPER_ID = "javascript-debugging-tools-wrapper";
            var JAVASCRIPT_CONSOLE_ID = "javascript-debugging-ios-console";
            var CONSOLE_ROLE_ATT_NAME = 'data-lfl-ios-js-console-role';

            // Note: Is technically not a console, since it does not allow input yet, but we still call it that way.
            var consoleInserted = false;
            var consoleReadyToRead = false;
            var consoleMessagesStack = [];

            var $console;
            var $consoleContainer;
            var $consoleTextArea;
            var $consoleOpenButton;
            var $consoleCloseButton;

            var consoleOpened = false;
            /**
             * Note: not just closed, entirely hidden.
             */
            var consoleHidden;

            /*
             |-------------------------------------------------------------------------
             | Init */
            FunctionsCaller.register(function () {
                consoleReadyToRead = true;
                _.each(consoleMessagesStack, function (message) {
                    MobileDebugger.consoleLog(message.text, message.type);
                })
            });

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            // Todo Later - finish the Alert if needed on mobile, or remove.
            // /**
            //  * Alerts a message.
            //  *
            //  * @memberOf Lfl.ZzDev.MobileDebugger
            //  */
            // MobileDebugger.alert = function () {
            //     throw new Error("Not implemented yet.");
            // };


            // TODO Later - allow multiple parameters to be passed as 'variable' into all log methods.
            //      E.g., `Lfl.ZzDev.MobileDebugger.consoleLog("Touch scrolling on ", e.target);` which is browser standard.
            //      Proposal:  Could be passed onwards in an array created from the parameters.

            /**
             * Outputs an info message to the console.
             *
             * @memberOf Lfl.ZzDev.MobileDebugger
             */
            MobileDebugger.consoleLogInfo = function (variable) {
                logIntoConsole(variable, 'info');
            };

            /**
             * Outputs a warning message to the console.
             *
             * @memberOf Lfl.ZzDev.MobileDebugger
             */
            MobileDebugger.consoleLogWarning = function (variable) {
                logIntoConsole(variable, 'warning');
            };

            /**
             * Outputs an alert/danger message to the console.
             *
             * @memberOf Lfl.ZzDev.MobileDebugger
             */
            MobileDebugger.consoleLogAlert = function (variable) {
                logIntoConsole(variable, 'danger');
            };

            /**
             * Outputs a message to the console.
             *
             * @memberOf Lfl.ZzDev.MobileDebugger
             */
            MobileDebugger.consoleLog = function (variable) {
                MobileDebugger.consoleLogInfo(variable);
            };

            MobileDebugger.openConsole = function () {
                openConsole();
            };

            MobileDebugger.closeConsole = function () {
                closeConsole();
            };

            MobileDebugger.hideConsole = function () {
                hideConsole();
            };

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
            // TODO Later - ZzDev::AddJsDebuggingForIos::II - rework into a separate console object with "classic"
            //      methods like colo, cowar, coalt, etc.

            function logIntoConsole(variable, type) {
                if (true !== consoleReadyToRead) {
                    consoleMessagesStack.push({text: variable, type: type});
                    return;
                }

                if (true !== consoleOpened) {
                    openConsole();
                }

                $consoleTextArea.append(createConsoleLine(variable, type));
            }

            function openConsole() {
                if (true !== consoleInserted || true === consoleHidden) {
                    showConsole();
                }

                $consoleContainer.addClass('ios-js-console-opened');
                $consoleContainer.removeClass('ios-js-console-closed');
            }

            function showConsole() {
                if (true !== consoleInserted) {
                    insertConsole();
                }

                if (true === consoleHidden) {
                    $console.show();
                }
            }

            function insertConsole() {
                $console = $("#" + JAVASCRIPT_CONSOLE_ID);
                if ($console.length === 0) {
                    // Yes, this will get lost on iOS, but we will be notified while debugging it in the browser or
                    // Rollbar can catch it, etc.
                    console.warn("Unable to open the iOS debugging console.");
                }

                // TODO Later - ZzDev::AddJsDebuggingForIos::II - move to an AJAX request to download this from the server.
                $console.html(getConsoleTemplate());
                $consoleContainer = $console.find('[' + CONSOLE_ROLE_ATT_NAME + '~="container"]');
                $consoleOpenButton = $console.find('[' + CONSOLE_ROLE_ATT_NAME + '~="openButton"]');
                $consoleCloseButton = $console.find('[' + CONSOLE_ROLE_ATT_NAME + '~="closeButton"]');
                $consoleTextArea = $console.find('[' + CONSOLE_ROLE_ATT_NAME + '~="textArea"]');

                $consoleOpenButton.on('click', function () {
                    openConsole();
                });

                $consoleCloseButton.on('click', function () {
                    closeConsole();
                });

                consoleInserted = true;
            }

            function closeConsole() {
                $consoleContainer.addClass('ios-js-console-closed');
                $consoleContainer.removeClass('ios-js-console-opened');
            }

            function hideConsole() {
                // TODO Later - ZzDev::AddJsDebuggingForIos::II - could use some defensive programming, like "if is set
                //      and is not empty"
                $console.hide();
                consoleHidden = true;
            }

            function createConsoleLine(content, type) {
                if (typeof type === 'undefined') {
                    type = 'info';
                }

                var text = Lfl.ZzDev.VarPrinter.print(content);
                text = formatText(text);

                var lineClass = getConsoleLineClassByType(type);

                return '<p class="ios-js-console-line ' + lineClass + '">' +
                    '<span class="ios-js-console-line-time">' + moment().format('LTS') + ':</span>' + ' '
                    + text + '</p>';
            }

            function getConsoleLineClassByType(type) {
                switch (type) {
                    case 'info':
                        return 'ios-js-console-line-type-info';
                    case 'warning':
                        return 'ios-js-console-line-type-warning';
                    case 'danger':
                        return 'ios-js-console-line-type-danger';
                    default:
                        return 'ios-js-console-line-type-unknown';
                }
            }

            function getConsoleTemplate() {
                //noinspection JSAnnotator
                return '' +
                    '<div class="ios-js-console-container" data-lfl-ios-js-console-role="container">' +
                    '       <div class="ios-js-console-open-button-wrapper" data-lfl-ios-js-console-role="openButtonWrapper">' +
                    '          <button class="ios-js-console-open-button" data-lfl-ios-js-console-role="openButton">' +
                    '              <i class="fa fa-terminal"></i>' +
                    '          </button>' +
                    '      </div>' +
                    '      <div class="ios-js-console-bar-wrapper" data-lfl-ios-js-console-role="barWrapper">' +
                    '          <div class="ios-js-console-bar-text">' +
                    '              <span> iOS Javascript output </span>' +
                    '          </div>' +
                    '          <div class="ios-js-console-bar-right float-right">' +
                    '              <button class="ios-js-console-close-button" data-lfl-ios-js-console-role="closeButton">' +
                    '                 <i class="fa fa-angle-down"></i>' +
                    '               </button>' +
                    '           </div>' +
                    '       </div>' +
                    '       <div class="ios-js-console-text-area-wrapper" data-lfl-ios-js-console-role="textAreaWrapper">' +
                    '           <div class="ios-js-console-text-area" data-lfl-ios-js-console-role="textArea">' +
                    '               <!-- Output will come here -->' +
                    '           </div>' +
                    '       </div>' +
                    '</div>'
                    ;
            }

            function formatText(text) {
                text = text.replace(/(?:\r\n|\r|\n)/g, '\n');

                // Note: If we wanted to format spaces, tabs, etc... we can use the following expression:
                //       text.replace(/^(\s)+/gm, function(match) {
                //          return "&nbsp;".repeat(match.length);
                //       });

                // And if we didn't want to use white-space:pre, we could use this:
                // text = text.replace(/\n/, '<br>');

                return text;
            }
        }(ZzDev.MobileDebugger, jQuery));
    }(Lfl.ZzDev, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
